"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEmbeddedUrlDto = instanceOfEmbeddedUrlDto;
exports.EmbeddedUrlDtoFromJSON = EmbeddedUrlDtoFromJSON;
exports.EmbeddedUrlDtoFromJSONTyped = EmbeddedUrlDtoFromJSONTyped;
exports.EmbeddedUrlDtoToJSON = EmbeddedUrlDtoToJSON;
exports.EmbeddedUrlDtoToJSONTyped = EmbeddedUrlDtoToJSONTyped;
/**
 * Check if a given object implements the EmbeddedUrlDto interface.
 */
function instanceOfEmbeddedUrlDto(value) {
    if (!('embeddedUrl' in value) || value['embeddedUrl'] === undefined)
        return false;
    if (!('signatureId' in value) || value['signatureId'] === undefined)
        return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined)
        return false;
    return true;
}
function EmbeddedUrlDtoFromJSON(json) {
    return EmbeddedUrlDtoFromJSONTyped(json, false);
}
function EmbeddedUrlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'embeddedUrl': json['embeddedUrl'],
        'signatureId': json['signatureId'],
        'expiresAt': (new Date(json['expiresAt'])),
    };
}
function EmbeddedUrlDtoToJSON(json) {
    return EmbeddedUrlDtoToJSONTyped(json, false);
}
function EmbeddedUrlDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'embeddedUrl': value['embeddedUrl'],
        'signatureId': value['signatureId'],
        'expiresAt': value['expiresAt'].toISOString(),
    };
}
